import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import styles from "./services.module.scss";

const introduction = () => {
  return (
    <Typography className={styles.details}>
      The goal of GASSC Spiritual Activity is to promote and provide assistance
      to spiritual and vaanaprastha aashrama practitioners during their Golden
      age. This program also intends to promote the overall well-being of
      members in their quest for inner peace, contentment, and joy. Key
      objectives include spiritual mentoring, practical application, forming
      study groups and sathsanghs to understand and apply principles of
      vedhaantha and yoga.The objectives, key success factors, and tactical
      activity plan for 2018 is provided below.
    </Typography>
  );
};

const objectives = () => {
  return (
    <Typography className={styles.details}>
      <ul style={{ paddingRight: 0, margin: 0 }}>
        <li>Create a Mentoring Portal for spirituality</li>
        <li>Create a portal for practice of vaanaprastha aashrama</li>
        <li>
          Be a communication bridge for sanathana Dharma principles and practice
        </li>
        <li>
          Provide a platform to familiarize, learn, or study vedhic scriptures
        </li>
        <li>
          Build alliances with agencies who promote spirituality and study of
          vedhic scriptures
        </li>
        <li>Encourage satellite sathsanghs in key Bay Area cities</li>
        <li>Create mailing list of spiritual seekers</li>
      </ul>
    </Typography>
  );
};
const succesFactores = () => {
  return (
    <Typography className={styles.details}>
      <ul style={{ paddingRight: 0, margin: 0 }}>
        <li>Promotion of spiritual activities</li>
        <li>Effectiveness of Service Providers</li>
        <li>Signup of mentors and spiritual seekers</li>
        <li>Signup of mentees for mentors</li>
        <li>Signup of Service Providers</li>
        <li>Signup for sathsanghs</li>
      </ul>
    </Typography>
  );
};

const activityPlan = () => {
  return (
    <Typography className={styles.details}>
      <ol style={{ paddingRight: 0, margin: 0 }}>
        <li>
          Enlist mentors of spirituality and identify their topics
          specialization
        </li>
        <li>Offer lectures of mentors periodically</li>
        <li>
          Host communication platform for spiritual discussions such as blogs,
          WhatsApp, Skype, and other media
        </li>
        <li>
          Start a repository for spiritual literature in physical and digital
          formats
        </li>
        <li>Enlist Service Providers for various programs of spirituality</li>
        <li>
          Offer academic courses on vedhaantha, yoga, and spiritual principles
        </li>
        <li>
          Create self-study groups for vedhaantha literature such as bhagavadh
          geetha, upanishadhs, and pathanjali yoga soothra
        </li>
        <li>Create 'Rules of Engagement' for sathsanghs</li>
        <li>
          Initiate and support at least three satellite sathsanghs in greater
          Bay Area territory
        </li>
        <li> Create mailing list</li>
      </ol>
    </Typography>
  );
};
const earthQuake = () => {
  return (
    <div className={styles.positioncontent}>
      <Grid className={styles.download}>
        <div className={styles.imageposition}>
          <div className={styles.positionicon}>
            <img src="/images/Ellipse_broucher.svg" />
            <img src="/images/ga2.svg" className={styles.downloadicon} />
          </div>
          <Typography className={styles.downloadtext}>
            <a
              href="http://image.msmail.morganstanley.com/lib/fe9413737562077971/m/1/FEMA_B-526_Earthquake_Safety_Checklist_110217_508.pdf"
              target="_blank"
              style={{ textDecoration: "none", color: "#882E14" }}
            >
              {" "}
              Safety Checklist
            </a>
          </Typography>
        </div>
      </Grid>
      <Grid className={styles.downloadbroucher}>
        <div className={styles.imageposition}>
          <div className={styles.positionicon2}>
            <img src="/images/Ellipse_broucher.svg" />
            <img src="/images/ga1.svg" className={styles.artical} />
          </div>
          <Typography className={styles.downloadtext}>
            <a
              href="https://www.ready.gov/earthquakes"
              target="_blank"
              style={{ textDecoration: "none", color: "#882E14" }}
            >
              What to do
            </a>{" "}
          </Typography>
        </div>
      </Grid>
    </div>
  );
};

const SpritualActivities = () => {
  return (
    <Box className={styles.goldenAgersActivityConatiner}>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>Introduction</Typography>
        {introduction()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>Objectives</Typography>
        {objectives()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>Success Factors</Typography>
        {succesFactores()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>
          2018 Activity Plan
        </Typography>
        {activityPlan()}
      </Box>
      <Box className={styles.singleSection}>
        <Typography className={styles.mainheadings}>Earth Quake</Typography>
        {earthQuake()}
      </Box>
    </Box>
  );
};

export default SpritualActivities;
